var _path, _circle;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgCameraIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 46,
    height: 36,
    viewBox: "0 0 46 36",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M42.4349 5.59832H30.5233L28.118 1.55564C27.8827 1.16038 27.457 0.918213 26.9972 0.918213H19.4321C18.9723 0.918213 18.5465 1.16038 18.3113 1.55564L15.906 5.59832H11.9973V4.7073C11.9973 3.98667 11.4133 3.40242 10.693 3.40242H5.86698C5.14653 3.40242 4.5627 3.98667 4.5627 4.7073V5.59832H3.99454C2.18301 5.59832 0.714722 7.06743 0.714722 8.87949V32.6369C0.714722 34.4491 2.18301 35.9182 3.99439 35.9182H42.4349C44.2463 35.9182 45.7147 34.4491 45.7147 32.6369V8.87949C45.7149 7.06743 44.2463 5.59832 42.4349 5.59832ZM23.2146 30.098C18.0587 30.098 13.8791 25.9165 13.8791 20.758C13.8791 15.5999 18.0587 11.4182 23.2146 11.4182C28.3706 11.4182 32.5502 15.5999 32.5502 20.758C32.5502 25.9165 28.3706 30.098 23.2146 30.098ZM36.3017 12.3631H40.3886C41.1091 12.3631 41.6931 11.7789 41.6931 11.0581C41.6931 10.3373 41.1092 9.75307 40.3886 9.75307H36.3017C35.5814 9.75307 34.9974 10.3373 34.9974 11.0581C34.9974 11.7789 35.5814 12.3631 36.3017 12.3631Z",
    fill: "black"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 23.2147,
    cy: 20.4182,
    r: 6.5,
    fill: "black"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCameraIcon);
export default __webpack_public_path__ + "static/media/camera-icon.18b6c1f8.svg";
export { ForwardRef as ReactComponent };